import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

export const FixtureSlicer = createSlice({
  name: 'Fixture',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList[]>,
  reducers: {
    getFixture: (state, _) => {
      state.isLoading = true;
    },
    successGetFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearFixtureState: (state) => {
      state.data = {};
    },
  },
});

export const {
  getFixture,
  failureGetFixture,
  successGetFixture,
  clearFixtureState,
} = FixtureSlicer.actions;

export default FixtureSlicer.reducer;
